const doRectsIntersect = function(r1, r2){
  let res = !(r2.left > r1.right || 
    r2.right < r1.left || 
    r2.top > r1.bottom ||
    r2.bottom < r1.top);

  return res;
}

export default  function requestPopupPosition({position,guideOutline, width, height}){
  //1. must be inside window
  //2. must not intersect with guideline items
  //  PROBLEM: it should be the INTERACTIVE guideline items,
  //  not the #redbeard 
  //  or the other thing surrounding the click-drag items.
  //  so we'll need to address that after.

  let [left,top] = position;
  let right = left + width;
  let bottom = top + height;


  let windowRight = window.innerWidth;
  let windowBottom = window.innerHeight;
  let insideWindow = (
    (0 <= left && right <= windowRight)
    &&
    (0 <= top && bottom <= windowBottom)
  );

  if( !insideWindow ){
    return false;
  }

  

  let guideLeft = guideOutline.left;
  let guideRight = guideOutline.left + guideOutline.width;
  let guideTop = guideOutline.top;
  let guideBottom = guideTop + guideOutline.height;

  let endpoints = Array.from(document.querySelectorAll('[tutorialrole=endpoint]')).map(x => x.getBoundingClientRect()); 
  if( endpoints.length > 0 ){

    guideLeft = Math.min(...endpoints.map(x => x.left)); 
    guideTop = Math.min(...endpoints.map(x => x.top)); 
    guideRight = Math.max(...endpoints.map(x => x.left + x.width))// - guideLeft;
    guideBottom = Math.max(...endpoints.map(x => x.top + x.height));

  }


  let RectA = { left:guideLeft, right:guideRight, top:guideTop, bottom: guideBottom };
  let RectB = { left, right, top, bottom }

  let messageIntersectsGuideline = doRectsIntersect(RectA,RectB)

  if(  messageIntersectsGuideline ){ 
    return false;
  }else{
  }

  //NO INTERSECTION WITH MUIPOPOVER:
  let muiPopoverClass = '.style-toolbar > .MuiPaper-root.MuiPopover-paper.MuiPaper-elevation8.MuiPaper-rounded'
  let muiPopover = document.querySelector(muiPopoverClass);
  let popoverMessages = document.querySelectorAll('#tutorial-popup');

  let elementsToAvoid = [ muiPopover, ...popoverMessages ];

  let intersectsSomeElementToAvoid = elementsToAvoid.some(el => {
    if( el ){

      let elRect = el.getBoundingClientRect();
      let elLeft = elRect.left;
      let elRight = elRect.left + elRect.width;
      let elTop = elRect.top;
      let elBottom = elRect.top + elRect.height;

      let elBounds = { left:elLeft,right:elRight,top:elTop,bottom:elBottom}

      let elIntersect = doRectsIntersect(RectB, elBounds);
      return elIntersect;

    }
  })

  return !intersectsSomeElementToAvoid;

}
